export default __webpack_public_path__ + "static/realWorldImg5-861a9ac6fc68bf74ff095020d0cc8707.webp";